<template>
  <div>
    <v-date-picker
      v-if="noMinDate"
      :disabled-dates="disableWeekend ? { weekdays: [1, 7] } : { weekdays: [] }"
      color="green"
      :input="['DD-MM-YYYY', 'DD/MM/YYYY', 'DD.MM.YYYY']"
      :model-config="modelConfig"
      v-model="dataDate" >
      <template class="input-text d-block" v-slot="{ inputValue, updateValue, showPopover }">
        <InputText
          :label="label"
          :value="inputValue || value"
          :placeholder="label"
          @focus="showPopover"
          @input="
            updateValue($event, {
              formatInput: true,
              hidePopover: true,
              debounce: 150,
            })
          "
          @change="
            updateValue($event, {
              formatInput: true,
              hidePopover: true,
            })
          "
          :rules="rules"
        />
      </template>
    </v-date-picker>
    <v-date-picker
      v-else
      :min-date='minDateProp'
      :disabled-dates="disableWeekend ? { weekdays: [1, 7] } : { weekdays: [] }"
      color="green"
      :input="['DD-MM-YYYY', 'DD/MM/YYYY', 'DD.MM.YYYY']"
      :model-config="modelConfig"
      v-model="dataDate" >
      <template class="input-text d-block" v-slot="{ inputValue, updateValue, showPopover }">
        <InputText
          :label="label"
          :value="inputValue || value"
          :placeholder="label"
          @focus="showPopover"
          @input="
            updateValue($event, {
              formatInput: true,
              hidePopover: true,
              debounce: 150,
            })
          "
          @change="
            updateValue($event, {
              formatInput: true,
              hidePopover: true,
            })
          "
          :rules="rules"
        />
      </template>
    </v-date-picker>
  </div>
</template>

<script>
/* eslint-disable */
import InputText from "@/components/elements/inputs/text.vue";
import rules from "@/mixins/rules";

export default {
  name: "Calendar",
  mixins: [rules],
  components: {
    InputText,
  },
  props: {
    value: {
      type: [String, Date],
      default: '',
    },
    date: {
      type: null,
    },
    label: {
      type: String,
      default: "",
    },
    noMinDate: {
      type: Boolean,
      default: false,
    },
    noDate: {
      type: Boolean,
      default: false,
    },
    disableWeekend: {
      type: Boolean,
      default: true,
    },
    minDateProp: {
      type: [String, Date],
      default: () => {
        return new Date();
      }
    }
  },
  data() {
    return {
      dataDate: this.date,
      modelConfig: {
        type: 'string',
        mask: 'YYYY-MM-DD',
      },
    };
  },
  mounted() {
    this.$nextTick(() => {
      if(this.noDate) return;
      if(this.date === undefined || this.date == '') {
        let freshDate = new Date();
        let d = new Date();
        if (freshDate.getDay() == 6) {
          d.setDate(freshDate.getDate() + 2);
        }

        if (freshDate.getDay() == 0) {
          d.setDate(freshDate.getDate() + 1);
        }

        let month = '' + (d.getMonth() + 1);
        let day = '' + d.getDate();
        let year = d.getFullYear();
        if (month.length < 2)
            month = '0' + month;
        if (day.length < 2)
            day = '0' + day;

        this.dataDate = [year, month, day].join('-');
        this.$emit('input', this.dataDate);
      } else {
        this.$emit('input', this.date);
        this.dataDate = this.date;
      }
    })
  },
  watch: {
    dataDate: function(newVal, oldVal) {
      this.$emit('input', newVal);
    },
    'date': function() {
      this.dataDate = this.date;
    },
  },
};
</script>
